// extracted by mini-css-extract-plugin
export var footer = "_pp-5";
export var fulfillmentInput = "_pp-0";
export var shipDateInput = "_pp-1";
export var shipmentModal = "_pp-2";
export var shipmentModalContent = "_pp-3";
export var tableContainer = "_pp-4";